export default "/static/dashboard/build/app/img/v2/9d0e08b2adefb27dc6967768e0d21f79.png";